import React from 'react';
import { withFirebase } from '../../../Firebase';
import { deleteUserEmailFromLocalStorage } from '../../../Firebase/localStorageForUserInfo';

const signOut = firebase => {
  firebase.signOut().then(() => {
    localStorage.removeItem('dashboardFilter');
    deleteUserEmailFromLocalStorage();
    window.location.href = '/login';
  });
};
const SignOutButton = ({ firebase }) => (
  <li onClick={() => signOut(firebase)}>
    <span>Log Out</span>
  </li>
);

export default withFirebase(SignOutButton);



// WEBPACK FOOTER //
// ./src/features/shared-components/Header/signOut.js